module.exports = __webpack_public_path__ + "img/img_login_foto.01ee3e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_login_foto.jpg
// module id = ./src/assets/images/img_login_foto.jpg
// module chunks = 22